import * as _ from "lodash";
import { IElementUpdate } from "../../../interface/IElementUpdate";
import { IForm } from "../../../interface/IForm";
import { IFormElement } from "../../../interface/IFormElement";
import {
    ValidationHelper
} from "../Validation";
import {
    FormElementHelper
} from "../../Utils/Element";
import { IOption } from "../../../interface/IOption";
import {
	UI_DYNAMIC_CONFIG_ELEMENT_TYPES,
	UI_ELEMENT_TYPES,
	UI_BTN_ACTIONS,
	UI_DYNAMIC_ELE_TYPES,
	ALL_OPTION_VALUE,
	ALL_OPTION_OBJ,
	ADD_FORM_ELEMENTS,
	MULTI_FORM_VERSION,
} from "../../../../config";
import { DateUtil } from "../../Utils/Date";
import { IFormElementValue } from "../../../interface/IFormElementValue";
import { EditSelectElement } from "./Select";
import { DateValidation } from "../Validation/Date";
import { IFormGroup } from "../../../interface/IFormGroup";
import { UtilHelper } from "../../Utils";

// Edit form class
export class EditForm {

    private validationHelper: ValidationHelper;
    private elementHelper: FormElementHelper;
    private dateUtil: DateUtil;
    private editSelectElement: EditSelectElement;
    private dateValidation: DateValidation;

    constructor() {
        this.validationHelper = new ValidationHelper();
        this.elementHelper = new FormElementHelper();
        this.dateUtil = new DateUtil();
        this.editSelectElement = new EditSelectElement();
        this.dateValidation = new DateValidation();
    }

    /**
     * Update the form
     *
     * @param {IForm[]} forms.
     * @param {IElementUpdate} element.
     * @param {boolean} isDelayed DEFAULT false. - Validate the field when use stop typing
     * @return {IForm[]} forms.
     */
    public updateForms = async (forms: IForm[], element: IElementUpdate, elementValue: IFormElementValue): Promise<IForm[]> => {
        const Forms: IForm[] = [];

        for (const form of forms) {
            const FormGroups = [];
            for (const formGroup of form.groups) {
                const FormElementArray = [];
                if (_.isEqual(element.formGroupId,formGroup.id)) {
                    for (const formElement of formGroup.elements) {
                        console.log("FormElement: ", formElement.id);
                        const Element = await this.updateElement(formElement, element, elementValue);
                        FormElementArray.push(Element);
                    }
                    FormGroups.push({
                        ...formGroup,
                        elements: FormElementArray,
                    });
                } else {
                    FormGroups.push(formGroup);
                }
            }

            Forms.push({
                ...form,
                groups: FormGroups
            });
        }

        return Forms;
    }

    updateChildIds = (configEle:IFormElement,forms: IForm[],newID:any,configArray:any): any =>{
        const getChildIDinfo:any=[];
        for (const form of forms) {
            for (const formGroup of form.groups) {
                for (const formElement of formGroup.elements) {
                        if(!_.isEmpty(formElement.parent_elements) && _.includes(formElement.parent_elements,configEle.id)){
                                getChildIDinfo.push({id: formElement.id, add_parent:newID});
                        }
                }
            }
        }
        return _.differenceBy(getChildIDinfo,configArray,"id");
    }



    updateParentIds = (configEle:IFormElement,configElements:any,formElement: IFormElement,elementValue: IFormElementValue):any =>{
        const parents = configEle.parent_elements;
        const modifiedParents:any = [];

        if(_.gt(parents.length,0)){
            const configIds = configElements.map((ele:any) => (ele.id));
            const independentParent = parents.map(parent => (configIds.includes(Number(parent)) ? null : parent)); 
            const parentIdToModify = [
                ...parents.filter(item => !independentParent.includes(item)),
                ...independentParent.filter((item:any) => !parents.includes(item))
              ].filter(item => item !== null); // Remove null values
               

            configElements.forEach((configElement:IFormElement,index:number)=>{
                for(const pt of parentIdToModify){
                    if(_.isEqual(_.toString(pt),_.toString(configElement.id))){
                        const getnewId = ((_.isEqual(formElement.id % 1, 0) ? 150 : 1000) + (configElement.id + Number(elementValue)) + ((index + 1) / 10));
                        modifiedParents.push(_.toString(getnewId));
                    }
                }
            });
            const result = [...independentParent, ...modifiedParents].filter(value => value !== null);
            return {result:result,
                isOnlyIndependent: _.gt(independentParent.length,0) &&
                _.isEqual(modifiedParents.length,0)
             };
        }
    }

    private updatebyAddingElement = async (formElement: IFormElement, elementValue: IFormElementValue,forms: IForm[]): Promise<any> => {
        const currentelement = {...formElement};
        if (_.isEqual(currentelement.type_id, UI_ELEMENT_TYPES.ADD_BUTTON)) {
            const getchildElementsArray:any=[];
            const dynamicConfig = _.isString(currentelement.add_dynamic_elements) ? JSON.parse(currentelement.add_dynamic_elements) : currentelement.add_dynamic_elements;
            const parentModified: any = [];
            const deleteId: any = { id: null, values: [] };
            if (!_.isEqual(formElement.id % 1, 0) && _.isEqual(dynamicConfig.sourceId % 1, 0)) {
                dynamicConfig.sourceId += MULTI_FORM_VERSION;
            }
            const updatedParents: any = [];
            const configElementsArray: IFormElement[] = dynamicConfig.elements.map((configElement: IFormElement, index: number, allitem: IFormElement[]) => {

                const configElementParents: any = _.gt(configElement.parent_elements?.length, 0) &&
                    this.updateParentIds(configElement, dynamicConfig.elements, formElement, elementValue);

                updatedParents.push(configElementParents.result);
                const getnewId = ((_.isEqual(formElement.id % 1, 0) ? 150 : 1000) + (configElement.id + Number(elementValue)) + ((index + 1) / 10));

                const getchildElements:any = this.updateChildIds(configElement,forms,getnewId,dynamicConfig.elements);
                getchildElementsArray.push([...getchildElements]);

                if (_.isEqual(dynamicConfig.deleteToShow.id, configElement.id)) {
                    deleteId["id"] = getnewId;
                    deleteId["values"].push(getnewId);
                } else {
                    deleteId.values.push(getnewId);
                }

                for (const parent of dynamicConfig.parentsToModify) {
                    if (_.isEqual(parent.id, configElement.id)) {
                        parentModified.push({ id: getnewId });
                    }
                }
                const l: number = allitem.length - 1;
                let dataSorceCopy: any;
                if (!_.isNull(configElement.api_url)) {
                    for (const form of forms) {
                        for (const formGroup of form.groups) {
                            for (const formEle of formGroup.elements) {
                                if (!_.isEmpty(formEle.dataSource) && _.isEqual(formEle.id, configElement.id) && 
                                        (configElementParents.isOnlyIndependent ||  
                                        _.isEqual(configElementParents.result.length, 0))) {
                                    dataSorceCopy = formEle.dataSource;
                                }
                            }
                        }
                    }
                }

                return {
                    ...configElement, id: getnewId, dataSource: dataSorceCopy,
                    display_order: ((Number(allitem[l].display_order)) + ((index + 1) / 10))
                };
            });

            configElementsArray.forEach((configEle: IFormElement, index: number) => {
                if (_.isEqual(deleteId.id, configEle.id)) {
                    configEle.deletebyIds = deleteId.values;
                }
                configEle.parent_elements = _.isUndefined(updatedParents[index]) ? 
                                            [] : updatedParents[index].map(parseFloat);
            });

            return { ...dynamicConfig, elements: configElementsArray,getchildElements:getchildElementsArray,
                  deleteToShow: deleteId };
        } else {
            return [];
        }

        
    }

    public addFormElements = async (forms: IForm[], newElements: any): Promise<IForm[]> => {
        const Forms: IForm[] = [];
        for (const form of forms) {
            const FormGroups = [];
            for (const formGroup of form.groups) {
                const FormElementArray = []; // Copy existing elements;
                let getchildElements = [];
                for (const formElement of formGroup.elements) {
                    const ElementArray:any = _.isEqual(newElements?.formElement?.id,formElement.id) && await this.updatebyAddingElement(formElement, newElements.value,forms);
                    if(_.gt(ElementArray?.elements?.length, 0)){
                        getchildElements = ElementArray.getchildElements;
                        for(const ele of ElementArray.elements){
                            FormElementArray.push(ele);
                        }
                        const ele = {...formElement};
                        ele.add_dynamic_elements = ElementArray;
                        ele.value = newElements.value;                    
                        FormElementArray.push(ele);
    
                    }else{
                        FormElementArray.push(formElement);
                    }
                   
                }
                if (_.gt(getchildElements?.length, 0)) {
                    for (const ele of FormElementArray) {
                        for (const childEleArr of getchildElements) {
                            for (const childEle of childEleArr) {
                                if (_.isEqual(childEle.id, ele.id)) {
                                    ele.parent_elements.push(childEle.add_parent);
                                }
                            }
                        }
                    }
                }
    
                FormGroups.push({
                    ...formGroup,
                    elements: FormElementArray,
                });
            }
    
            Forms.push({
                ...form,
                groups: FormGroups
            });
        }
    
        return Forms;
    }
    
    public getaddButtonElements = async (forms: IForm[], elementId: any): Promise<IFormElement[]> => {
        const formElementArray:IFormElement[]=[];
        for(const form of forms){
            for(const formGroup of form.groups){
                for (const formElement of formGroup?.elements) {
                    if (_.isEqual(formElement.type_id,UI_ELEMENT_TYPES.ADD_BUTTON) && _.isEqual(elementId,formElement.id)) {
                        for(const x of  formElement.add_dynamic_elements.elements){
                            formElementArray.push(x);
                        }
                    }
                }
            }
        }
        return formElementArray;
    }    
    
	//Display multi form for Element
	public showAddForm = (forms: IForm[]):any => {
    	for(const form of forms){
    		for(const formGroup of form.groups){
    			for(const formElement of formGroup.elements){
					if(ADD_FORM_ELEMENTS.includes(formElement.value?.value) && forms.filter(x => x.id%1 ===0)){
						return true;
					}
    			}
    		}
    	}
    	return false;
    }

    public isValidParentElement = (parentElementId: any, forms: any): any => {
        if (parentElementId) {
            let isValidParent = false;
            for (const form of forms) {
                for (const formGroup of form?.groups) {
                    for (const formElement of formGroup?.elements) {
                        if (_.isEqual(formElement.id, (parentElementId + MULTI_FORM_VERSION))) {
                            isValidParent = true;
                        }
                    }
                }
            }
            return isValidParent;
        }
    }

    public mapElementids = (ids: any,formversion:any,notadditionalForms:any):any =>{
        let dataIds:any;
        for (const form of notadditionalForms) {
            for (const group of form.groups) {
               dataIds = _.map(group.elements, "id");
            }
        }
        return _.map(ids,(item)=>{
            if(item?.id){
              return  _.includes(dataIds,item.id) ? {...item} : {...item,id:(item.id + formversion)};
            }else{
              return  _.includes(dataIds,item) ? item : item + formversion;
            }
        });
	}
 public checkdepends = (ele: any,dependent_values:any,notadditionalForms:any):any =>{
    let item:any;
    const utilHelper = new UtilHelper();
    for (const form of notadditionalForms) {
        for (const group of form.groups) {
            item = _.find(group.elements,{id:ele.depends_on});
            if(!_.isEmpty(item?.value)){
                const eleValue = utilHelper.getElementValue(item);
                return utilHelper.isDependentValueMatch(eleValue,dependent_values,ele.dependency_exact);
            }
        }
    }
    return ele.is_visible;
 }

    public mapDynamicElements = (elements: any, formVersion: any, notadditionalForms: any,cloneFlag:boolean): any => {
        const elementsarray = [];
        for (const element of elements.elements) {
            const elementsUpdate: any = element;
            elementsUpdate.id = Number(elementsUpdate.id + formVersion); 
            if (!_.isEqual(elementsUpdate?.parent_elements, null)) {
                elementsUpdate.parent_elements = this.mapElementids(elementsUpdate.parent_elements, 
                                                            formVersion, notadditionalForms);
            }
            if (!_.isEqual(elementsUpdate?.depends_on, null)) {
                elementsUpdate.depends_on = _.head(this.mapElementids([elementsUpdate.depends_on],
                                                             formVersion, notadditionalForms));
            }
            elementsarray.push(elementsUpdate);

        }
        const vals = _.map(elements.deleteToShow.values, value => value + formVersion);
        return {...elements ,
            elements: elementsarray,
            parentsToModify:this.mapElementids(elements.parentsToModify, 
                                                            formVersion, notadditionalForms),
            sourceId:elements.sourceId + formVersion,
            deleteToShow:{...elements.deleteToShow,id: _.head(this.mapElementids([elements.deleteToShow.id],
                                                             formVersion, notadditionalForms)),
                                                            values:cloneFlag ? vals : elements.deleteToShow.values}
        };
    }

    public getLastFormIdVersion = (forms: any):any =>{
        return (forms[forms.length - 1].id).toString().split(".")[1] ?? null;
    }

    public isValidMultiForms = (forms: any): boolean =>{
        return (forms?.some((x:any) => !x.isValid));
    }

    public replaceDatasetValue = (forms: IForm[], element:IFormElement):any=>{
        for (const form of forms) {
                for (const group of form.groups) {
                    for(const ele of group.elements){
                        if(_.isEqual(ele.id,element.id)){
                            return {...element,
                                value:_.isNull(ele.default_value) ? null : ele.value,
                                dataSource:ele.dataSource
                            };
                        }
                    }
                }
            }
    }

    public elementValueUpdate = (defaultForm:any,forms:any):any =>{
        return defaultForm.map((form: IForm) => ({
            ...form,
            groups: form.groups.map((formGroup: IFormGroup) => ({
                ...formGroup,
                elements: formGroup.elements.map((formElement: IFormElement) => {
                     const element  = this.replaceDatasetValue(forms,formElement);
                     return {...element};
                })
            }))
        }));
    }

    public updateDataSetValues = (forms: IForm[],additionalForms:IForm[]): any => {
        let  dataSetElements:any = [];
        for(const form of forms){
            for(const formGroup of form.groups){
                const elements =  _.filter(formGroup.elements,(u)=>_.has(u,"dataset_values"));
                if(_.gt(elements.length,0)){
                    dataSetElements = _.concat(dataSetElements,elements);
                }
            }
        }
        let modifiedForm:any = _.cloneDeep(additionalForms);
        for(const element of dataSetElements){
            if((_.isEmpty(element.value))){
                modifiedForm = this.elementValueUpdate(modifiedForm,forms);
            }
        }
        return modifiedForm;
    }

    public cloneValueornot = (val: any, ele: IFormElement): any => {
        return {
            value: ele.not_to_clone ? null : val,
            isValid: ele.not_to_clone ? false : ele.isValid
        };
    }

    public cloneElements = (elements:IFormElement[],formVersion:number,notadditionalForms:any):any =>{
            return elements.map((ele:IFormElement)=>{
                const dynamicConfig = !_.isNull(ele.add_dynamic_elements) &&
                            _.isString(ele.add_dynamic_elements) ? 
                            JSON.parse(ele.add_dynamic_elements) : 
                            (!_.isUndefined(ele.add_dynamic_elements)?ele.add_dynamic_elements:null);
                if (ele.deletebyIds){
                    ele.deletebyIds =_.map(ele.deletebyIds, value => value + formVersion);
                }
                const dO = !_.isNull(ele.depends_on) ? _.toNumber(_.head(this.mapElementids([ele.depends_on],formVersion,notadditionalForms))):null;
                return{
                    ...ele,
                    id:ele.id+formVersion,
                    parent_elements :!_.isNull(ele.parent_elements) ? this.mapElementids(ele.parent_elements,formVersion,notadditionalForms):[],
                    depends_on :dO,
                    parent_compare_element_id : !_.isNull(ele?.parent_compare_element_id) ? (ele?.parent_compare_element_id+formVersion):null,
                    add_dynamic_elements : !_.isUndefined(ele.add_dynamic_elements) && !_.isNull(ele.add_dynamic_elements) ? 
                                            this.mapDynamicElements(dynamicConfig, formVersion,notadditionalForms,true) :null,
                    ...this.cloneValueornot(ele.value,ele),
                };
            });
    }
    public cloneForm = (Forms:IForm[],displayOrder:number,formVersion:number,notadditionalForms:any):any =>{
        const mx_id = _.maxBy(Forms.filter((obj:any)=> _.isNull(obj.parentId)), "display_order")?.display_order;
        const clone_forms = _.cloneDeep(Forms.filter((obj:any)=>_.gte(obj.display_order,mx_id)));
        return clone_forms.map((form: IForm,index:number)=>{
            const _do = displayOrder + index;
            if(_.isEqual(form.parentId,null)){
                form.isMultiCountFlag = true;
			}else if(!_.isUndefined(form.parentId)){
                form.parentId = Number(((Number(form.parentId) + formVersion)).toFixed(2));
            }
            const formTitle = _.trim(_.replace(form.title, /\d+/g, ""));
            return {
                ...form,
                display_order:(_do+1),
                isVisible:true,
                isMulti:true,
                id:Number(((Number(form.id) + formVersion)).toFixed(2)),
                title:formTitle + " "+ 2,
                groups:form.groups.map((formGroup: IFormGroup)=>{
                    return {
                        ...formGroup,
                        id:Number((Number((formGroup.id)+formVersion)).toFixed(2)),
                        elements:this.cloneElements(formGroup.elements,formVersion,notadditionalForms)
                    };
                })
            };
        });
    }

	//Update the forms array with additional form with empty values
	public updateFormsForAdd = async (tool: any, currentFormId: any,isClone:boolean):  Promise<IForm[]> =>{
		const Forms:IForm[] = [];
		const { forms, defaultForms } = tool;
		for(const form of forms){
		Forms.push(form);	
    	}
        const initialFormList:IForm[] = _.cloneDeep(defaultForms);
		let additionalForms : IForm[]=[];
        const notadditionalForms: IForm[]=[];

        let displayOrder = Forms[Forms.length - 1].display_order;
        const lastFormId = this.getLastFormIdVersion(Forms);
        const formVersion = Number(((_.isNull(lastFormId) ? Number(lastFormId) : (Number("0."+lastFormId))) + MULTI_FORM_VERSION).toFixed(2));

        for (const form of initialFormList) {
            if (_.isEqual(form.id, currentFormId) || _.isEqual(form.parentId, currentFormId)) {
                additionalForms.push(form);
            } else {
                const id = form.id;
                notadditionalForms.push(_.find(forms, { id: id }));
            }
        }
        if (isClone) {
            const cloneFormData:IForm[] = this.cloneForm(Forms, displayOrder, MULTI_FORM_VERSION,notadditionalForms);
            const validateForm = this.validationHelper.isValidForms(cloneFormData);
            for(const x of validateForm){
                Forms.push(x);
            }
            return this.maintainFormTitle(Forms);

        } else {
            additionalForms = this.updateDataSetValues(forms, additionalForms);
        }

		for(const newForm of additionalForms){
			newForm.display_order = displayOrder + 1;
			newForm.id =Number(Number(newForm.id + formVersion).toFixed(2)); 
			if(_.isEqual(newForm.parentId,null)){
                newForm.isMultiCountFlag = true;
			}else if(!_.isUndefined(newForm.parentId)){
                newForm.parentId = Number(((Number(newForm.parentId) + formVersion)).toFixed(2));
            }
			newForm.title=newForm.title + " "+(lastFormId ? _.toInteger(lastFormId)+1 : 2);
			newForm.isVisible = true;
            newForm.isMulti = true;
            newForm.loading = false;
            const formsGroups: any =[];
            for(const formGroup of newForm.groups){
                const formElementgroups:any={...formGroup};
                formElementgroups.elements =[];
    			for(const formElement of formGroup.elements){
                    const eleUpdate: IFormElement= {...formElement};
                    if(_.isEqual(formElement.id%1,0)) {
                        eleUpdate.id = formElement.id+formVersion;
                    }
                    if(!_.isEqual(formElement?.parent_elements,null)){
                        eleUpdate.parent_elements = 
                            this.mapElementids(formElement.parent_elements,formVersion,notadditionalForms);
                    }
                    if(!_.isEqual(formElement?.depends_on,null)){
                        eleUpdate.depends_on = 
                            _.toNumber(_.head(this.mapElementids([formElement.depends_on],formVersion,notadditionalForms)));
                        eleUpdate.is_visible = this.checkdepends(formElement,formElement.dependent_values,notadditionalForms);
                    }
                    if(!_.isEqual(formElement?.parent_compare_element_id,null)){
                        eleUpdate.parent_compare_element_id = formElement?.parent_compare_element_id+formVersion;
                    }
                    if(!_.isEqual(formElement.add_dynamic_elements,null)){
                        const dynamicConfig = 
                            _.isString(formElement.add_dynamic_elements) ? 
                            JSON.parse(formElement.add_dynamic_elements) : formElement.add_dynamic_elements;
                        eleUpdate.add_dynamic_elements = 
                            this.mapDynamicElements(dynamicConfig, formVersion,notadditionalForms,false);
                    }
                    if(!_.isNull(formElement.default_value)){
                        eleUpdate.value = formElement.value;
                    }

                    formElementgroups.elements.push(eleUpdate);
                }
                formsGroups.push(formElementgroups);
            }
            newForm.groups = formsGroups;
			Forms.push(newForm);
			displayOrder++;
		}
		return this.maintainFormTitle(Forms);
	}

	//Update forms array by removing specific additional forms
	public updateFormsForRemove = async (forms: IForm[], formId: any):  Promise<IForm[]> =>{
        const remainForms = _.filter(forms,item => !(_.isEqual(item.id, formId) || _.isEqual(item.parentId, formId)));
		return this.maintainFormTitle(remainForms);
	}

	public maintainFormTitle = (forms: IForm[]):any =>{
		let endNumber = "";
		let count = 0;
		return forms.map((x: any) => {
			if (!_.isInteger(x.id) && x.isMulti && x?.isMultiCountFlag) {
				count = ++count;
				endNumber = (x.id).toString().split(".")[1];
			}
			if (_.isEqual((x.id).toString().split(".")[1], endNumber)) {
				return { ...x, title: _.replace(x.title, /\d+$/, count.toString()) };
			} else {
				return { ...x };
			}
		});
	}

    /**
     * Update the element
     *
     * @param {IFormElement} formElement.
     * @param {IElementUpdate} element.
     * @param {boolean} isDelayed DEFAULT false.
     * @return {IForm[]} forms.
     */
    private updateElement = async (formElement: IFormElement, element: IElementUpdate, elementValue: IFormElementValue): Promise<IFormElement> => {
        let updatedElement = {
            ...formElement,
        };
        if (_.isEqual(formElement.id, element.formElement.id)) {
            let value = element.value;

            // DatePicker
            if (_.isEqual(formElement.type_id, UI_ELEMENT_TYPES.DATETIME_INPUT)
                && !formElement.is_number) {
                value = this.dateUtil.formatDateOrTime(value, formElement);
                formElement.dateInput = element.formElement.dateInput;
            }
            else if (_.isEqual(formElement.type_id, UI_ELEMENT_TYPES.FILE_INPUT)) {
                if (!_.isNull(formElement.dynamic_configuration)
                    && formElement.load_data_to_grid) {
                    if (!_.isNull(element.dynamicElement)
                        && !_.isUndefined(element.dynamicElement)) {
                        formElement.error = "";
                        if (_.isEqual(element.dynamicElement.action, UI_BTN_ACTIONS.EDIT)) {
                            const dynamicFieldValues = element.dynamicElement.value;
                            const { defaultSort } = formElement.dynamic_configuration;
                            const DefaultOrderBy = !_.isNull(
                                defaultSort
                            )
                                ? defaultSort
                                : null;
                            const DefaultOrder = !_.isNull(DefaultOrderBy) ? "asc" : null;
                            formElement.dynamic_fields_values = !_.isNull(DefaultOrderBy) && !_.isNull(DefaultOrder)
                                ? _.orderBy(dynamicFieldValues, [DefaultOrderBy], [DefaultOrder]) : dynamicFieldValues;
                        }
                        else if (_.isEqual(element.dynamicElement.action, UI_BTN_ACTIONS.DELETE)) {
                            formElement.dynamic_fields_values = [];
                        } else if (_.isEqual(element.dynamicElement.action, UI_BTN_ACTIONS.UPLOAD)) {
                            if (!_.isEmpty(element.dynamicElement.errorMessage)) {
                                formElement.error = element.dynamicElement.errorMessage;
                                formElement.dynamic_fields_values = [];
                            } else {
                                const dynamicFieldValues = element.dynamicElement.value;
                                const { defaultSort } = formElement.dynamic_configuration;
                                const DefaultOrderBy = !_.isNull(
                                    defaultSort
                                )
                                    ? defaultSort
                                    : null;
                                const DefaultOrder = !_.isNull(DefaultOrderBy) ? "asc" : null;
                                formElement.dynamic_fields_values = !_.isNull(DefaultOrderBy) && !_.isNull(DefaultOrder)
                                    ? _.orderBy(dynamicFieldValues, [DefaultOrderBy], [DefaultOrder]) : dynamicFieldValues;
                            }

                        }
                    }
                }
            }
            // Select 
            else if (_.isEqual(formElement.type_id, UI_ELEMENT_TYPES.SELECT_INPUT)) {
                value = this.editSelectElement.updateSelectValue(formElement, element);


                if (!_.isNull(element.value)) {
                    if (formElement.is_multi) {
                        const UpdatedValue = value;
                        const Values = UpdatedValue.filter((option: IOption) => option.highlightOption);
                        formElement.highlight_option_error = _.isEqual(Values.length, 0) ? "" : "Please remove options in red as they no longer exist.";
                    } else {
                        formElement.highlight_option_error = !element.value.highlightOption ? "" : "Please remove the option as it is no longer exist.";
                    }
                } else {
                    formElement.highlight_option_error = "";
                }
                if (!_.isNull(formElement.dynamic_configuration)
                    && _.isEqual(formElement.dynamic_configuration.elementType, UI_DYNAMIC_CONFIG_ELEMENT_TYPES.METRICS)) {

                    let dynamicElements = formElement.dynamic_fields_values.map((ele: any) => ({ ...ele }));

                    if (_.isEqual(element.dynamicElement.action, UI_BTN_ACTIONS.ADD)) {
                        const DynamicElement = formElement.dynamic_element.children[dynamicElements.length];
                        dynamicElements.push({ ...DynamicElement, value: null, touched: false });
                    }
                    else if (_.isEqual(element.dynamicElement.action, UI_BTN_ACTIONS.EDIT)) {

                        const DynamicElement = dynamicElements[element.dynamicElement.index];
                        if (_.isNull(element.dynamicElement.value)) {
                            DynamicElement.value = null;
                            DynamicElement.sortby = null;
                        }
                        else if (!_.isEqual(element.dynamicElement.value.value, _.isNull(element.formElement.value) ? null : element.formElement.value.value)) {

                            dynamicElements = formElement.dynamic_fields_values.map((ele: any) => ({ ...ele }));
                            let sortByValue = _.isEqual(element.dynamicElement.type, UI_DYNAMIC_ELE_TYPES.SORT) ? element.sortByValue.value : null;

                            if (!_.isNull(element.dynamicElement.value)
                                && _.isEqual(element.dynamicElement.type, UI_DYNAMIC_ELE_TYPES.ELEMENT)) {

                                const DynamicElements = (formElement.dynamic_element.children || []).filter((ele: any) => !_.isNull(ele.value));

                                const Value = DynamicElements.find((ele: any) => _.isEqual(ele.value.value, element.dynamicElement.value.value));

                                sortByValue = Value.sortby;
                            }

                            DynamicElement.value = _.isNull(element.dynamicElement.value) ? null : element.dynamicElement.value;
                            DynamicElement.sortby = sortByValue;
                        }


                        dynamicElements[element.dynamicElement.index] = { ...DynamicElement, touched: true };
                    } else if (_.isEqual(element.dynamicElement.action, UI_BTN_ACTIONS.DELETE)) {
                        dynamicElements = dynamicElements.filter((val: any, index: number) => !_.isEqual(index, element.dynamicElement.index));
                    }

                    value = { label: "dummy", value: "dummy" };
                    let isValid = true;

                    for (const dynamiceEle of dynamicElements) {
                        if (_.isNull(dynamiceEle.sortby) || (_.isNull(dynamiceEle.value) && dynamiceEle.required)) {
                            isValid = false;
                        }
                    }

                    formElement.dynamic_fields_values = dynamicElements;

                    value = isValid ? value : null;
                }

                if (formElement.is_multi && !_.isNull(formElement.selection_limit)
                    && !_.isNull(value)) {
                    const DataSource = (formElement.dataSource || []).map((option: IOption) => ({ ...option, isDisabled: false }));


                    const ValLen = formElement.allow_all ? value.length - 1 : value.length;

                    if (_.gte(ValLen, formElement.selection_limit)) {
                        formElement.dataSource = formElement.dataSource.map((option: IOption) => ({ ...option }))
                            .map((option: IOption) => ({ ...option, isDisabled: true }));
                    } else {
                        formElement.dataSource = DataSource;
                    }

                    if (formElement.is_multi && !_.isNull(formElement.selection_limit)
                        && !_.isNull(value) && _.isArray(value)) {
                        formElement = this.elementHelper.updateSelectionLimit(formElement, value);
                    }
                }
            }

            let touched = true;

            if (_.isEqual(formElement.type_id, UI_ELEMENT_TYPES.DATERANGE_INPUT)) {
                touched = this.dateValidation.isValidTouchForDateRange(element.value);
            }
            if(_.isEqual(formElement.type_id, UI_ELEMENT_TYPES.MODAL_BUTTON)){
				updatedElement = {...formElement,
                    isValid: !_.isNull(element.value)};
			}

            updatedElement = {
                ...formElement,
                touched,
                value,
                loading: element.loading,
                input_event_value: element.formElement.input_event_value
            };
        }
        else if ((_.isEqual(formElement.type_id, UI_ELEMENT_TYPES.TEXT_INPUT)
            || _.isEqual(formElement.type_id, UI_ELEMENT_TYPES.CHIP)
            || _.isEqual(formElement.type_id, UI_ELEMENT_TYPES.DOWNLOAD))
            && !this.validationHelper.isPreviousAndCurrentValueAreSame(
                element.formElement,
                elementValue
            )
            && !_.isEqual(formElement.parent_elements.indexOf(element.formElement.id), -1)) {
            let errorMessage = "";
            if (formElement.is_required) {
                errorMessage = await this.validationHelper.validate(formElement,
                    null);
            }
            updatedElement = {
                ...formElement,
                value: _.isEqual(formElement.type_id, UI_ELEMENT_TYPES.DOWNLOAD) ? null : "",
                touched: false,
                error: errorMessage,
                isValid: _.isEqual(errorMessage.length, 0),
            };
        }
        else if ((_.isEqual(formElement.type_id, UI_ELEMENT_TYPES.SELECT_INPUT)
            || _.isEqual(formElement.type_id, UI_ELEMENT_TYPES.THUMBNAIL))
            && !this.validationHelper.isPreviousAndCurrentValueAreSame(
                element.formElement,
                elementValue
            )
            && !_.isEqual(formElement.parent_elements.indexOf(element.formElement.id), -1)) {

            let errorMessage = "";
            if (formElement.is_required) {
                errorMessage = await this.validationHelper.validate(formElement,
                    null);
            }
            updatedElement = {
                ...formElement,
                value: null,
                dynamic_fields_values: [],
                touched: false,
                error: errorMessage,
                dataSource: [],
                hideBasedOnParent: true,
                is_visible: formElement.is_visible,
                isValid: _.isEqual(errorMessage.length, 0),
            };
        }
        else if ((_.isEqual(formElement.type_id, UI_ELEMENT_TYPES.GRID))
            && !this.validationHelper.isPreviousAndCurrentValueAreSame(
                element.formElement,
                elementValue
            )
            && !_.isEqual(formElement.parent_elements.indexOf(element.formElement.id), -1)) {
            let errorMessage = "";
            let validflag = true;
            if (formElement.is_required) {
                errorMessage = await this.validationHelper.validate(formElement,
                    null);
                validflag = formElement.dataSource.length > 0 ? true : false;
            }

            updatedElement = {
                ...formElement,
                value: null,
                dynamic_fields_values: [],
                touched: false,
                error: formElement.dataSource.length > 0 ? "" : errorMessage,
                hideBasedOnParent: true,
                is_visible: formElement.is_visible,
                isValid: validflag
            };
        }
        return {
            ...updatedElement
        };
    }

        /**
         * Update creatable select value
         *
         * @param {IFormElement} formElement.
         * @param {any} element.
         * @return {any} value.
         */
        updateSelectValue = (formElement: IFormElement, value: any): any => {

            const {
                is_multi,
                allow_all
            } = formElement;

            if (is_multi && allow_all) {
                const Value = value || [];

                const IsAllOptionSelected = (Value).findIndex(
                    (option: IOption) => {
                        return _.isEqual(option.value, ALL_OPTION_VALUE);
                    }
                );

                if (
                    _.isEqual(IsAllOptionSelected, Value.length - 1) &&
                    _.gt(Value.length, 1)
                ) {
                    return [ALL_OPTION_OBJ];
                } else if (
                    !_.isEqual(IsAllOptionSelected, -1) &&
                    _.gt(Value.length, 1)
                ) {
                    return Value.filter(
                        (option: IOption) => !_.isEqual(option.value, ALL_OPTION_VALUE)
                    );
                }
            }
            return value;
        }

      /**
     * Update creatable select data source
     *
     * @param {IForm[]} forms.
     * @param {IFormElement} element.
     * @param {IOption} option.
     * @return {IForm[]} forms.
     */
      public async updateElementDataSource(forms: IForm[], element: IElementUpdate): Promise<IForm[]> {
        try {
            const Forms: IForm[] = [];
            for (const form of forms) {
                const FormGroups: IFormGroup[] = [];
                for (const formGroup of form.groups) {
                    const Elements: IFormElement[] = [];
                    for (const formElement of formGroup.elements) {
                        if (_.isEqual(formElement.id, element.formElement.id)
                            && _.isEqual(UI_ELEMENT_TYPES.SELECT_INPUT, element.formElement.type_id)) {

                            let updatedDataSource: any = [...formElement.dataSource,
                            element.newOption];
                            updatedDataSource = _.orderBy(updatedDataSource, [(op: IOption) => op.label.toLowerCase()], ["asc"]);

                            Elements.push({
                                ...formElement,
                                dataSource: updatedDataSource,
                            });
                        } else {
                            Elements.push({
                                ...formElement
                            });
                        }

                    }
                    FormGroups.push({
                        ...formGroup,
                        elements: Elements,
                    });
                }
                Forms.push({
                    ...form,
                    groups: FormGroups,
                });
            }
            return Forms;
        }
        catch {
            return [];
        }
    }
}